module.exports = __webpack_public_path__ + "img/oy.064ac032.png";